<template>
  <div class="gradient-bg full-screen d-flex position-relative">
    <!-- Floating Background Shapes -->
    <div class="floating-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
      <div class="shape shape-5"></div>
      <div class="shape shape-6"></div>
    </div>

    <!-- Left Side - Branding -->
    <div class="left-section d-none d-lg-flex flex-column justify-content-center align-items-center position-relative">
      <div class="brand-container text-center">
        <div class="brand-logo mb-4">
          <svg class="brand-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5" />
          </svg>
        </div>
        <h1 class="brand-title mb-3">{{ appName || 'HRM Pro' }}</h1>
        <p class="brand-subtitle mb-4">Secure Password Reset Portal</p>
      </div>
    </div>

    <!-- Right Side - Reset Form -->
    <div class="right-section d-flex align-items-center justify-content-center position-relative">
      <!-- Notification -->
      <div v-show="notification.show" :class="['notification', notification.type, { 'show': notification.show }]">
        {{ notification.message }}
      </div>

      <!-- Reset Card -->
      <div class="login-container">
        <div class="glass-effect login-card position-relative overflow-hidden">

          <!-- Mobile Header -->
          <div class="mobile-header text-center mb-4 d-lg-none">
            <div class="logo-container d-flex align-items-center justify-content-center mx-auto mb-3">
              <img v-if="logoUrl" :src="logoUrl" alt="Logo" class="img-fluid logo">
              <svg v-else class="logo-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16" />
              </svg>
            </div>
            <h2 class="login-title-mobile fw-bold text-white mb-2">{{ appName || 'HRM Pro' }}</h2>
            <p class="login-subtitle-mobile">Password Reset</p>
          </div>

          <!-- Welcome Header -->
          <div class="welcome-header text-center mb-4">
            <h3 class="welcome-title text-white mb-2">Forgot your password?</h3>
            <p class="welcome-subtitle">Enter your email to request a reset link</p>
          </div>

          <!-- Reset Form -->
          <form class="sign-in-sign-up-form" ref="form" data-url="users/password-reset" @submit.prevent="submitData">

            <!-- Email Field -->
            <div v-if="!message" class="form-group mb-4">
              <label class="form-label text-white fw-medium mb-2">Email Address</label>
              <div class="position-relative">
                <div class="input-icon">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12" />
                  </svg>
                </div>
                <input type="email" class="form-control glass-input input-focus" v-model="formData.email"
                       placeholder="Enter your email address" required>
              </div>
              <div v-if="$errorMessage(errors, 'email')" class="error-message">
                {{ $errorMessage(errors, 'email') }}
              </div>
            </div>

            <!-- Thank You Message -->
            <div v-else class="form-group text-center text-white mb-4">
              {{ message }}
            </div>

            <!-- Submit Button -->
            <div class="form-group mb-4">
              <button type="submit" v-if="!message" :disabled="loading"
                      class="btn login-btn btn-hover w-100 d-flex align-items-center justify-content-center">
                <span>{{ loading ? 'Processing...' : 'Request Reset Link' }}</span>
                <div v-if="loading" class="loading-spinner ms-2"></div>
              </button>

              <!-- Back Button after success -->
              <a v-else :href="urlGenerator('/')" class="btn login-btn w-100">Back to Login</a>
            </div>

            <!-- Footer -->
            <div class="text-center">
              <p class="footer-text mt-3 mb-0">
                © {{ new Date().getFullYear() }} {{ appName || 'HRM Pro' }}. All rights reserved.
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ThemeMixin from "../../../../core/mixins/global/ThemeMixin";
import FormHelperMixins from "../../../Mixin/Global/FormHelperMixins";

export default {
  mixins: [ThemeMixin, FormHelperMixins],
  name: "PasswordReset",
  props: {
    logoUrl: { required: false },
    appName: { required: false }
  },
  data() {
    return {
      notification: {
        show: false,
        message: '',
        type: 'success'
      }
    };
  },
  methods: {
    submitData() {
      this.loading = true;
      this.save(this.formData);
    },
    afterSuccess({ data }) {
      this.message = data.message || 'A password reset link has been sent to your email.';
      this.showNotification('Reset link sent! Check your inbox.', 'success');
    },
    showNotification(message, type = 'success') {
      this.notification.message = message;
      this.notification.type = type;
      this.notification.show = true;
      setTimeout(() => { this.notification.show = false; }, 4000);
    }
  },
  mounted() {
    const card = this.$el.querySelector('.login-card');
    card.style.opacity = '0';
    card.style.transform = 'translateY(30px) scale(0.98)';

    setTimeout(() => {
      card.style.transition = 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)';
      card.style.opacity = '1';
      card.style.transform = 'translateY(0) scale(1)';
    }, 200);
  }
};
</script>

<style scoped>
@import '../../../../../sass/LoginPageStyles.css'; /* reuse login styles */
</style>
